// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"887":"5115839c","946":"5115839c"}[chunkId] + ".chunk.css";
};